import {Button, Alert} from 'reactstrap';
import React from "react";

const DispositionPendingWarningAlert = (props) => (
	<Alert className={'brittanys-test-component'} color={props.color ? '' : 'danger'} style={{backgroundColor: props.color ?? ''}} data-cy={"disposition-warning"}>
		<p style={{fontSize: '18px', marginBottom: '0px', color: props.textColor ?? 'black'}}>
			{!props.hideButton && !props.noIgnore && <Button onClick={props.onAlertDismiss} color={'danger'} size={'sm'} className={'pull-right'} style={{marginRight: '-6px', marginLeft: '15px', marginTop: '-2px'}}>
				<i className={'fa fa-ban'} />&nbsp;&nbsp;Ignore
			</Button>}
			{props.noIgnore && <Button onClick={props.onAlertDismiss} size={'sm'} className="btn btn-sm blue-hoki pull-right" style={{marginRight: '-6px', marginLeft: '15px', marginTop: '-2px'}}>
				{props.noIgnore}
			</Button>}
			<span className={props.warningName ? 'd-inherit' : 'd-none'}><strong>{props.warningName}</strong> - </span>{props.warningMessage}
			{props.url && <a target={"_blank"} href={props.url}>
				<i >{props.urlText}</i>
				{/*<span>*/}
				{/*	<span>{props.url}</span>*/}
				{/*</span>*/}
			</a> }
		</p>
	</Alert>
)

export default DispositionPendingWarningAlert;
